import { Icon } from "design-react-kit";
import moment from "moment/moment";
import React, { useEffect, useRef } from "react";
import { useTranslate } from "react-admin";
import truncate from "truncate-html";
import "./HomeSlider.css";

const HomeSlider = ({ slides }) => {
  const swiperElRef = useRef(null);
  const translate = useTranslate();
  const dateFormat = translate("website.date.format.short");

  const getCategory = ({ tree }) => {
    return tree.split("/")[1] || "";
  };

  const getDate = ({ published }) => {
    return moment(published).format(dateFormat);
  };

  const getLink = ({ content_type, uuid }) => {
    return `/${content_type}?uuid=${uuid}`;
  };

  useEffect(() => {
    if (swiperElRef && swiperElRef.current) {
      const params = {
        injectStyles: [
          `
      :host .swiper-wrapper {
        padding-top: 34px;
      }
      :host .swiper-button-prev {
        position: absolute;
        top: 24px;
        right: 64px;
        left: auto;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        overflow: hidden;
        background-color: rgba(24, 9, 134, .48);
      }
      :host .swiper-button-next {
        position: absolute;
        top: 24px;
        right: 24px;
        left: auto;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        overflow: hidden;
        background-color: rgba(24, 9, 134, .48);
      }
      :host .swiper-button-prev:hover,
      :host .swiper-button-next:hover {
        background-color: rgba(24, 9, 134, 1);
      }
      :host .swiper-button-prev::after,
      :host .swiper-button-next::after {
        font-size: 10px;
        color: white;
      }
      :host .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        margin: 0 8px !important;
        background-color: rgba(24, 9, 134, .48);
        opacity: 1 !important;
      }
      :host .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background-color: rgba(24, 9, 134, 1);
      }
      :host .swiper-pagination {
        position: absolute;
        width: auto;
        top: 0;
        left: 24px;
        bottom: auto;
      }
      @media (min-width: 768px) {
        :host .swiper-wrapper {
          padding-top: 0;
          padding-bottom: 24px;
        }
        :host .swiper-pagination {
          width: 100%;
          position: relative;
          top: auto;
          left: auto;
        }
        :host .swiper-button-prev {
          top: 50%;
          right: auto;
          left: 10%;
        }
        :host .swiper-button-next {
          top: 50%;
          right: 10%;
          left: auto;
        }
      }
      `,
        ],
      };

      Object.assign(swiperElRef.current, params);

      swiperElRef.current.initialize();
    }
  }, [swiperElRef]);

  return (
    <div className="home-slider">
      <swiper-container
        ref={swiperElRef}
        pagination={true}
        pagination-clickable={true}
        navigation={true}
        loop={false}
        centered-slides={true}
        slides-per-view={1}
        init={false}
        auto-height={false}
      >
        {slides.map((slide, x) => (
          <swiper-slide key={x}>
            <div className="home-slider__slide">
              <div className="home-slider__slide__media">
                <img
                  alt="placeholder"
                  className="home-slider__slide__image"
                  src="/website/placeholder.png"
                />
              </div>
              <div className="home-slider__slide__data">
                <div className="home-slider__slide__date">
                  <span className="home-slider__slide__date-label">
                    {getCategory(slide)}
                  </span>
                  <span className="home-slider__slide__date-value">
                    {getDate(slide)}
                  </span>
                </div>
                <div className="home-slider__slide__title">{slide.name}</div>
                <div
                  className="home-slider__slide__description"
                  dangerouslySetInnerHTML={{
                    __html: truncate(slide.description, 32, { byWords: true }),
                  }}
                />
                <div className="home-slider__slide__tags">
                  {slide.tags.map((tag, y) => (
                    <div className="home-slider__slide__tag" key={y}>
                      {tag}
                    </div>
                  ))}
                </div>
                <div className="home-slider__slide__link">
                  <a href={getLink(slide)}>
                    <span>LEGGI DI PIÙ</span>
                    <Icon color="primary" icon="it-arrow-right" size="sm" />
                  </a>
                </div>
              </div>
            </div>
          </swiper-slide>
        ))}
      </swiper-container>
    </div>
  );
};

export default HomeSlider;
